import { AsyncPipe } from '@angular/common';
import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, combineLatest, filter, map, mergeMap, tap } from 'rxjs';

import { CurrencyService } from '@speedy/core';

@Component({
  standalone: true,
  selector: 'app-price',
  templateUrl: './price.component.html',
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComponent {
  private readonly currencyService = inject(CurrencyService);

  @Input()
  set price(value: string | number) {
    this._price = value;
    this.priceUpdated$.next(value);
  }
  get price() {
    return this._price;
  }

  @Input() noComma = false;

  private currentCurrency!: string;
  private _price!: string | number;

  priceUpdated$ = new BehaviorSubject<number | string>(0);

  price$ = combineLatest([
    this.currencyService.currentCurrency$,
    this.priceUpdated$,
  ]).pipe(
    tap(([currency]) => (this.currentCurrency = currency)),
    mergeMap(() => this.currencyService.exchangeRates$),
    filter((rates) => rates !== null),
    map((rates) => {
      const currentRate = rates?.find(
        (rate) => rate.currency_to === this.currentCurrency,
      );

      if (currentRate) {
        const price =
          (typeof this.price === 'string' ? parseFloat(this.price) : this.price) *
          currentRate.rate;

        if (this.noComma) {
          return price.toFixed(0);
        }

        return price.toFixed(2);
      }

      return this.price;
    }),
  );
}
